let updateHandler

class Update {
  constructor () {
    this.handlers = []
    this.intervalId = null
    this.animationFrameId = null
  }

  run (updatesPerSecond = 'auto') {
    clearInterval(this.intervalId)
    window.cancelAnimationFrame(this.animationFrameId)

    if (updatesPerSecond === 'auto') {
      updateHandler = this.updateAuto.bind(this)
      updateHandler()
    } else {
      updateHandler = this.updateInterval.bind(this)
      this.intervalId = setInterval(updateHandler, 1000 / updatesPerSecond)
    }
  }

  updateInterval () {
    for (const handler of this.handlers) handler.fn()
  }

  updateAuto () {
    this.animationFrameId = window.requestAnimationFrame(updateHandler)
    for (const handler of this.handlers) handler.fn()
  }
}

const update = new Update()

export function enableUpdate (updatesPerSecond) {
  update.handlers = []
  update.run(updatesPerSecond)
}

export function useUpdate (handler, options) {
  update.handlers.push({
    fn: handler,
    options
  })

  update.handlers.sort(function (a, b) {
    const aOrder = (a.options && typeof a.options.updateOrder === 'number')
      ? a.options.updateOrder
      : 0
    const bOrder = (b.options && typeof b.options.updateOrder === 'number')
      ? b.options.updateOrder
      : 0
    return aOrder - bOrder
  })
}
